/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable import/no-duplicates */
/* eslint-disable no-param-reassign */
/* eslint-disable no-return-assign */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react'

import { Link } from 'react-router-dom'

import {
  Container,
  ProfileImage,
  WrapperHeader,
  Content,
  M,
  DivInfo,
  DivName,
  ButtonCv,
  WrapperSections,
  BtnEdit,
  Ul,
  WrapperCv,
  DivLi,
  DivPlus,
  ImgTrash,
  WrapperImage,
  Card,
  Column,
  ContentCFM,
  Label,
  Paragraph,
  TitleCFM,
} from './styles'

import PrimaryHeader from '../../../components/primary-header'
import SwitchAvailability from '../../../components/switch-availability'
import Title from '../../../components/title'
import CardProfile from '../../../components/cardProfile'
import FormFactory from '../../../components/form/form-factory'
import Icon from '../../../components/icon'
import AvailabilitySchedule from '../../../components/availability-schedule'
import Modal from '../../../components/modal'

import download from '../../../assets/svg/download.svg'
import logout from '../../../assets/svg/logout-box-line.svg'
import lockImage from '../../../assets/svg/lock-password-line.svg'
import plus from '../../../assets/svg/add.svg'
import mail from '../../../assets/svg/mail.svg'
import trash from '../../../assets/svg/trash.svg'
import wpp from '../../../assets/svg/whatsapp-line.svg'

import IFormPage from '../../../interfaces/form-page'
import userIMG from '../../../assets/png/user-profile.png'
import TextArea from '../../contractors/profile/text-area'

import { ProfileProps } from './props'

import transformAvailability from '../../../helpers/helper-transform-availability'
import { subscriptionMapper } from '../../../helpers/helper-subscription'
import { PaymentType, RoutesEnum } from '../../../enums'
import { getRoute, LinkBuilder } from '../../../helpers'

type IProps = ProfileProps & IFormPage

const ProfileDoctor = ({
  setAvailable,
  available,
  editingFields,
  handleEditClick,
  setAboutValue,
  setObservationValue,
  handleRemoveSpecialtie,
  handleRemoveCity,
  handleCancellClick,
  pdfInputRef,
  handlePdfUpload,
  selectedFile,
  redirectToPlans,
  handleDownloadPdf,
  name,
  email,
  phone,
  about,
  address,
  specialties,
  workingPlaces,
  cities,
  availability,
  observation,
  imageUrl,
  handleLogout,
  handleAboutEdit,
  aboutValue,
  handleEditAddress,
  dataForm,
  dataform2,
  dataform3,
  onSubmit,
  handleUpdateCities,
  handleUpdateLocals,
  handleAddLocals,
  handleCommentsEdit,
  observationValue,
  handleRemoveLocal,
  handleEditAvailability,
  uploadCV,
  handleEditHeader,
  plan,
  subscription,
  billingModalOpen,
  toggleBillingModalVisibility,
  medico,
}: IProps): JSX.Element => (
  <Container>
    <Modal
      content={{
        title: 'Editar Perfil',
        component: () => (
          <div style={{ marginTop: 20, textAlign: 'justify' }}>
            Atenção! Identificamos que há pagamentos
            {' '}
            <strong>pendentes</strong>
            {' '}
            na sua conta. Regularize sua situação para continuar aproveitando
            todas as funcionalidades da plataforma. Estamos aqui para ajudar, se
            precisar!
          </div>
        ),
        width: '40%',
      }}
      hasHeader
      isVisible={billingModalOpen}
      toggleVisibility={toggleBillingModalVisibility}
    />
    <PrimaryHeader>
      <Title>
        <span>Voltar</span>
      </Title>
      <WrapperHeader>
        <DivInfo>
          <WrapperImage>
            <ProfileImage
              src={imageUrl ? LinkBuilder.buildAssetsUrl(imageUrl) : userIMG}
              alt="img"
            />
            <Link
              to={getRoute(RoutesEnum.EDIT_PROFILE_IMAGE, {
                userType: 'doctor',
              })}
            >
              Editar foto
            </Link>
          </WrapperImage>
          <div>
            <DivName>
              Olá, Dr(a).&nbsp;
              {name}
            </DivName>
            <DivInfo>
              <img src={mail} alt="email" />
              {email}
            </DivInfo>
            <DivInfo>
              <img src={wpp} alt="whatsapp" />
              {phone}
            </DivInfo>
          </div>
          <Icon
            name="edit-hollow"
            onClick={handleEditHeader}
            style={{ cursor: 'pointer' }}
          />
        </DivInfo>
        <SwitchAvailability available={available} onSwitch={setAvailable} />
      </WrapperHeader>
    </PrimaryHeader>
    <Content>
      <Card>
        <TitleCFM>CFM</TitleCFM>
        <ContentCFM>
          <Column>
            <Paragraph>
              <Label>CRM:</Label>
              {' '}
              {medico.crm || 'Não informado'}
            </Paragraph>
            <Paragraph>
              <Label>Especialidade:</Label>
              {medico.especialidade.length > 0 ? medico.especialidade.join(', ') : 'Não informado'}
            </Paragraph>
            <Paragraph>
              <Label>Inscrição:</Label>
              {' '}
              {medico.tipoInscricao || 'Não informado'}
            </Paragraph>
          </Column>
          <Column>
            <Paragraph>
              <Label>Data de Atualização:</Label>
              {' '}
              {medico.dataAtualizacao || 'Não informado'}
            </Paragraph>
            <Paragraph>
              <Label>Nome:</Label>
              {' '}
              {medico.nome || 'Não informado'}
            </Paragraph>
            <Paragraph>
              <Label>UF:</Label>
              {' '}
              {medico.uf || 'Não informado'}
            </Paragraph>
          </Column>
          <Column>
            <Paragraph>
              <Label>Data de Nascimento:</Label>
              {' '}
              {medico.dataNascimento || 'Não informado'}
            </Paragraph>
            <Paragraph>
              <Label>Situação:</Label>
              {' '}
              {medico.situacao || 'Não informado'}
            </Paragraph>
          </Column>
        </ContentCFM>
      </Card>
      <M>
        {editingFields.about ? (
          <>
            <CardProfile
              isEditing={editingFields.about}
              title="Sobre"
              showEdit={!subscription.hasPendingPayment}
              content={(
                <>
                  <TextArea
                    label="Sobre"
                    value={aboutValue}
                    onChange={(e) => setAboutValue(e.target.value)}
                    autoFocus={editingFields.about}
                    maxLength={5000}
                    style={{ height: '50px' }}
                  />
                  <BtnEdit
                    type="button"
                    onClick={() => {
                      handleAboutEdit()
                    }}
                  >
                    Salvar
                  </BtnEdit>
                </>
              )}
              cancelEdit={() => handleCancellClick('about')}
            />
          </>
        ) : (
          <>
            <CardProfile
              isEditing={editingFields.about}
              title="Sobre"
              content={about}
              handleEditClick={() => handleEditClick('about')}
              showEdit={!subscription.hasPendingPayment}
            />
          </>
        )}
        <CardProfile
          isEditing={editingFields.address}
          title="Endereço"
          content={`${address.number}, ${address.street}, ${address.city}, ${address.state}`}
          handleEditClick={() => handleEditAddress()}
          showEdit={!subscription.hasPendingPayment}
        />

        <CardProfile
          isEditing={editingFields.specialty}
          cancelEdit={() => handleCancellClick('specialty')}
          title="Especialidade(s)"
          showEdit={!subscription.hasPendingPayment}
          content={
            editingFields.specialty ? (
              <FormFactory data={dataForm} onSubmit={onSubmit} />
            ) : (
              <Ul>
                {specialties.map((item) => (
                  <DivLi>
                    <li key={`specialty-${item.name}${item.id}`}>
                      {item.name}
                    </li>
                    <ImgTrash
                      src={trash}
                      alt="Remover item"
                      onClick={() => handleRemoveSpecialtie(item.id)}
                    />
                  </DivLi>
                ))}
              </Ul>
            )
          }
          handleEditClick={() => handleEditClick('specialty')}
        />
        <CardProfile
          isEditing={editingFields.cities}
          cancelEdit={() => handleCancellClick('cities')}
          title="Cidades Atendidas"
          showEdit={!subscription.hasPendingPayment}
          content={
            editingFields.cities ? (
              <FormFactory data={dataform2} onSubmit={handleUpdateCities} />
            ) : (
              <Ul>
                {cities.map((item) => (
                  <DivLi>
                    <li key={`city-${item.name}${item.id}`}>{item.name}</li>
                    <ImgTrash
                      src={trash}
                      alt="Remover item"
                      onClick={() => handleRemoveCity(item.id)}
                    />
                  </DivLi>
                ))}
              </Ul>
            )
          }
          handleEditClick={() => handleEditClick('cities')}
        />
        <CardProfile
          isEditing={editingFields.availability}
          cancelEdit={() => handleCancellClick('availability')}
          title="Disponibilidade"
          showEdit={!subscription.hasPendingPayment}
          content={(
            <AvailabilitySchedule
              availability={transformAvailability(availability)}
            />
          )}
          handleEditClick={() => handleEditAvailability()}
        />
        <CardProfile
          isEditing={editingFields.medicalUnit}
          cancelEdit={() => handleCancellClick('medicalUnit')}
          title="Unidades Médicas"
          showEdit={!subscription.hasPendingPayment}
          content={
            editingFields.medicalUnit ? (
              <DivPlus>
                <FormFactory data={dataform3} onSubmit={handleUpdateLocals} />
                <img
                  src={plus}
                  alt="Adicionar item"
                  onClick={() => handleAddLocals()}
                  style={{ width: '40px', cursor: 'pointer' }}
                />
              </DivPlus>
            ) : (
              <Ul>
                {workingPlaces.map((item) => (
                  <DivLi>
                    <li key={`working-place-${item}`}>{item}</li>
                    <ImgTrash
                      src={trash}
                      alt="Remover item"
                      onClick={() => handleRemoveLocal(item)}
                    />
                  </DivLi>
                ))}
              </Ul>
            )
          }
          handleEditClick={() => handleEditClick('medicalUnit')}
        />

        {editingFields.comments ? (
          <>
            <CardProfile
              isEditing={editingFields.comments}
              cancelEdit={() => handleCancellClick('comments')}
              title="Observações"
              showEdit={!subscription.hasPendingPayment}
              content={(
                <>
                  <TextArea
                    label="Observações"
                    value={observationValue}
                    onChange={(e) => setObservationValue(e.target.value)}
                    autoFocus={editingFields.comments}
                    maxLength={1000}
                    style={{ height: '50px' }}
                  />
                  <BtnEdit
                    type="button"
                    onClick={() => {
                      handleCommentsEdit()
                    }}
                  >
                    Salvar
                  </BtnEdit>
                </>
              )}
            />
          </>
        ) : (
          <>
            <CardProfile
              isEditing={editingFields.comments}
              title="Observações"
              showEdit={!subscription.hasPendingPayment}
              content={observation}
              handleEditClick={() => handleEditClick('comments')}
            />
          </>
        )}
        <CardProfile
          isEditing={editingFields.cv}
          handleEditClick={() => handleEditClick('cv')}
          cancelEdit={() => handleCancellClick('cv')}
          title="Currículo"
          showEdit={!subscription.hasPendingPayment}
          content={
            editingFields.cv ? (
              <>
                <WrapperCv>
                  <label
                    htmlFor="fileInput"
                    style={{
                      cursor: 'pointer',
                      padding: '10px',
                      border: '1px solid #ccc',
                      borderRadius: '5px',
                    }}
                  >
                    Selecionar Currículo
                  </label>
                  <input
                    type="file"
                    accept=".pdf"
                    ref={pdfInputRef}
                    onChange={(e) => handlePdfUpload(e.target.files?.[0])}
                    style={{ display: 'none' }}
                    id="fileInput"
                  />
                  <span>{selectedFile}</span>
                </WrapperCv>
                {selectedFile && (
                  <ButtonCv
                    type="button"
                    onClick={() => uploadCV(pdfInputRef.current?.files?.[0])}
                  >
                    Enviar
                  </ButtonCv>
                )}
              </>
            ) : (
              <ButtonCv type="button" onClick={handleDownloadPdf}>
                <img src={download} alt="Baixar currículo" />
                Baixar currículo
              </ButtonCv>
            )
          }
        />

        <CardProfile
          isEditing={editingFields.plan}
          title="Seu plano"
          content={plan}
          handleEditClick={() => redirectToPlans()}
        >
          Pagamento:
          {' '}
          {subscriptionMapper[subscription.paymentMethod]}
          <div>
            {subscription.paymentMethod === PaymentType.BOLETO
              && subscription.urlBoletoPdf && (
                <ButtonCv
                  type="button"
                  onClick={() => {
                    window.open(subscription.urlBoletoPdf, '_blank')
                  }}
                >
                  <img src={download} alt="Baixar boleto" />
                  Baixar Boleto
                </ButtonCv>
            )}
          </div>
        </CardProfile>
      </M>
      <WrapperSections>
        <Link to={RoutesEnum.CHANGE_PASSWORD}>
          <img src={lockImage} alt="Alterar minha senha" />
          Alterar minha senha
        </Link>
        <Link to={RoutesEnum.INTRO} onClick={handleLogout}>
          <img src={logout} alt="Sair da plataforma" />
          Sair da plataforma
        </Link>
      </WrapperSections>
    </Content>
  </Container>
)
export default ProfileDoctor
